import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Hand, LineChart } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide04Approach({
  index
}: SlideProps) {
  const pillars = [{
    icon: Eye,
    title: 'Refresh attention',
    text: 'Make Amoxil feel active in the digital channel.',
    delay: 0.4
  }, {
    icon: Hand,
    title: 'Create participation',
    text: 'Use quizzes, polls, peer comparison, and choice-based journeys.',
    delay: 0.55
  }, {
    icon: LineChart,
    title: 'Capture insight',
    text: 'Understand which topics, channels, and messages drive HCP interest.',
    delay: 0.7
  }];
  return <InteriorSlide surface data-id="element-87">
      <SlideHeader eyebrow="Strategic Opportunity" data-id="element-88">
        For a legacy brand, engagement format can change brand perception
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-6xl mx-auto w-full" data-id="element-89">
        {/* Left: Video Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="flex-1 w-full relative aspect-[4/5] max-w-md rounded-3xl overflow-hidden shadow-2xl border-8 border-white" data-id="element-90">
          <video src="https://cdn.magicpatterns.com/uploads/aSaSDYcCo6i6NGsKPw3av6/eye.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-91" />
          <div className="absolute inset-0 bg-black/20 flex flex-col items-center justify-center text-center p-8" data-id="element-92">
            <p className="text-4xl md:text-5xl font-bold text-white tracking-tight leading-tight drop-shadow-md" data-id="element-93">
              Engagement
              <br data-id="element-94" />
              relevance
            </p>
          </div>
        </motion.div>

        {/* Right: Pillars */}
        <div className="flex-1 space-y-6 w-full" data-id="element-95">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-8" data-id="element-96">
            Amoxil has strong familiarity, but familiarity can also make
            communication feel predictable. Interactive campaign formats can
            make the brand feel more relevant, active, and worth engaging with
            again.
          </motion.p>

          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <motion.div key={pillar.title} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: pillar.delay,
            duration: 0.5
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-black/5 flex gap-6 items-center" data-id="element-97">
                <div className="h-14 w-14 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--brand)] flex-shrink-0" data-id="element-98">
                  <Icon className="h-7 w-7" data-id="element-99" />
                </div>
                <div data-id="element-100">
                  <h3 className="text-lg font-bold text-[var(--fg)] mb-1" data-id="element-101">
                    {pillar.title}
                  </h3>
                  <p className="text-[var(--muted)] text-sm leading-relaxed" data-id="element-102">
                    {pillar.text}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </InteriorSlide>;
}